import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit",
  "use": "edit-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"edit\"><g fill-rule=\"evenodd\"><path d=\"M0 15.97h16v-1H0zM2.023 12.946V10.47L9.42 3.232l2.428 2.428-7.416 7.286zm9.642-11.91l2.391 2.453-1.478 1.454-2.427-2.427zm3.11 3.183a1.06 1.06 0 00.318-.757 1.061 1.061 0 00-.312-.759L12.388.311a1.07 1.07 0 00-1.503-.006L1 10.041v3.928h3.85z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id